<template>
  <tbody class="user-list__user__table__tbody">
  <tr v-for="event in events" :key="event.event_id" class="user-list__user__table__event"
      :class="{'user-list__user__table__event--special': event.v_is_special}">
    <td>{{ event.v_start_and_endtime }} | <span class="d-tag" v-if="event.v_is_special">{{
        event.title
      }}</span><b v-else>{{ event.title }}</b></td>
    <td>{{ event.v_calendar_name }}</td>
    <td><span class="d-tag">{{ event.v_event_type_name }}</span>
    </td>
    <td>
      {{ event.v_substitute_for_name }}
      <span class="d-tag"
            v-if="event.v_substitute_for_employments.length > 0"
            :content='event.v_substitute_for_employments'
            v-tippy="{
                            arrow: true,
                            animateFill: false,
                            animation : 'shift-away',
                            zIndex: '999999992',
                            boundary: 'window',
                            onShow: () => event.v_substitute_for_employments.length > 1
                          }">
                      {{ event.v_substitute_for_employments[0] }}
                      <template v-if="event.v_substitute_for_employments.length > 1">m.fl.</template>
                    </span>
    </td>
    <td>
      <template v-if="userDay.state === 'draft'">
        <p class="text-explainer" v-if="user.v_user_active_employments.length < 1">Ingen ansættelser</p>
        <select class="no-print" v-else
                @change="updatePropOnLesson('employment_id', user, userDay, event, $event.target.value)"
                v-model.number="event.employment_id">
          <option v-for="userEmployment in user.v_user_active_employments" :value="Number(userEmployment.id)">
            {{ userEmployment.title }}
          </option>
        </select>
        <span class="only-print" :class="{'italic': event.v_employment_id_title === 'Ingen valgt'}">
          {{ event.v_employment_id_title }}
        </span>
      </template>
      <span v-else
            :class="{'d-tag': event.v_employment_id_title && event.v_employment_id_title !== 'Ingen valgt'}">{{
          event.v_employment_id_title
        }}
      </span>
    </td>
    <td v-if="isSalaryIntegrationActive">
      <select class="do-select"
              v-model.number="event.salary_code_id"
              :disabled="userDay.state !== 'draft'"
              @input="updatePropOnLesson('salary_code_id', user, userDay, event, $event.target.value)">
       <option value=""></option>
        <option v-for="salaryCode in salaryCodes" :key="salaryCode.loenart" :value="salaryCode.id">
          {{ salaryCode.name }}
        </option>
      </select>
    </td>
    <td v-if="costCenters.length > 0">
      <select class="no-print"
              :disabled="userDay.state !== 'draft'"
              @change="updatePropOnLesson('afv_omkostningssted', user, userDay, event, $event.target.value)"
              v-model.number="event.afv_omkostningssted">
        <option v-for="costCenter in costCenters" :value="Number(costCenter.code)">
          {{ costCenter.title }}
        </option>
      </select>
    </td>
    <td>
      {{ event.minutes }} min.
    </td>
  </tr>
  </tbody>
</template>
<script>
import moment from 'moment'

export default {
  props: {
    user: {
      type: Object
    },
    userDay: {
      type: Object
    },
    isSalaryIntegrationActive: {
      type: Boolean,
      default: false
    },
    salaryCodes: {
      type: Array,
      default: () => []
    },
    costCenters: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    events () {
      // Add custom props to each event
      return this.userDay.events.map(event => {
        const userEmployments = this.user.v_user_employments // this.userDay.getUserEmployments(this.userDay.user_id)
        return {
          ...event,
          v_is_special: event.event_type.startsWith('_extra_time_'),
          v_start_and_endtime: moment(event.start).format('LT') + ' - ' + moment(event.end).format('LT'),
          v_calendar_name: event.calendars ? this.getCalendarName(event) : '',
          v_substitute_for_employments: event.substitute_for_user_id ? this.getSubstituteForEmployments(event.substitute_for_user_id) : [],
          v_substitute_for_name: event.substitute_for_user_id && this.allUsersInHash[event.substitute_for_user_id] ? this.allUsersInHash[event.substitute_for_user_id]['name'] : '',
          v_event_type_name: this.getExtraEventTitle(event.event_type) || (this.$t('vue2.eventTypes.' + event.event_type) !== 'vue2.eventTypes.' + event.event_type
            ? this.$t('vue2.eventTypes.' + event.event_type)
            : event.event_type),
          v_employment_id_title: event.employment_id ? userEmployments.find(userEmployment => userEmployment.id === event.employment_id) ? userEmployments.find(userEmployment => userEmployment.id === event.employment_id)['title'] : event.employment_id : 'Ingen valgt'
        }
      })
    },
    employmentsInUserIdHash () {
      return this.$store.getters.employmentsInUserIdHash
    },
    allUsersInHash () {
      return this.$store.getters.allUsersInHash
    }
  },
  methods: {
    updatePropOnLesson (propToUpdate, user, userDay, event, val) {
      const obj = {propToUpdate, user, userDay, event, val}
      this.$emit('updatePropOnLesson', obj)
    },
    getCalendarName (event) {
      const calendar = event.calendars ? event.calendars.find(calEvent => calEvent.calendar_id === event.calendar_id) : null
      return calendar ? calendar.name : ''
    },
    getSubstituteForEmployments (substituteForUserId) {
      return this.getUserEmployments(substituteForUserId).map(employment => employment.title)
    },
    getUserEmployments (userId) {
      return this.employmentsInUserIdHash[userId] ? this.employmentsInUserIdHash[userId] : []
    },
    getExtraEventTitle (eventTitle) {
      const obj = {
        _extra_time_at_start_of_day_: 'Ekstra tid',
        _extra_time_if_shorter_than_: 'Ekstra tid',
        _extra_time_between_events_: 'Ekstra tid'
      }
      return obj[eventTitle]
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.user-list__user__table__tbody tr td {
  padding: 0.5rem;
}

.user-list__user__table__tbody {
  border-top: 1px solid #e2e8f0;
}

.user-list__user__table__tbody select {
  box-shadow: 0 0 0 0 transparent, 0 0 0 0 transparent, 0 1px 1px 0 rgba(0, 0, 0, .12), 0 0 0 1px rgba(64, 68, 82, .16), 0 0 0 0 transparent, 0 0 0 0 transparent, 0 2px 5px 0 rgba(64, 68, 82, .08);
  border-radius: 4px;
  background-color: #fff;
  border: 0;
  min-width: 160px;
}

.user-list__user__table tbody tr td:last-child {
  text-align: right;
}

.user-list__user__table tbody tr {
  transition: 0.15s;
}

.user-list__user__table tbody tr:nth-child(even) {
  background-color: #f9fafb;
}

.user-list__user__table tbody tr:hover {
  background-color: aliceblue;
}

.d-tag {
  font-size: .8rem;
  background: #f9fafb;
  padding: 0.25rem 0.4rem;
  color: #4b5563;
  border: 1px solid #ebedee;
  border-radius: 4px;
}

.user-list__user__table__event--special .d-tag {
  background: #fefce8;
  border-color: #f4e6c0;
  color: #854d0f;
}

.td-salary-input-number {
  width: 90px;
}

.do-input {
  background: #fff;
  height: 28px;
  box-shadow: 0 0 0 0 transparent, 0 0 0 0 transparent, 0 1px 1px 0 rgba(0, 0, 0, .12), 0 0 0 1px rgba(64, 68, 82, .16), 0 0 0 0 transparent, 0 0 0 0 transparent, 0 2px 5px 0 rgba(64, 68, 82, .08);
  border: 1px solid transparent;
}

@media print {
  .user-list__user__table__tbody tr td {
    font-size: 8px;
  }

  .d-tag {
    font-size: 8px;
  }

  .user-list__user__table__event--special .d-tag {
    background: #f9fafb;
    color: #4b5563;
    border: 1px solid #ebedee;
  }
}
</style>



// WEBPACK FOOTER //
// SalarySubsPerfUserDay.vue?30c71fb2